@if (HasRequiredPermissions) {
  @if (EntityInstance || isNew()) {
    <div [fieldContext]="this" class="flex flex-col max-h-[80vh]">
      <!-- Header -->
      <div class="px-8 pt-5 pb-3 border-b border-gray-200 flex justify-between items-center">
        <h4 class="text-lg font-semibold text-gray-700">
          @if (isNew()) { {{ 'entities.buzzer-config.newEntity' | translate }} }
            @else { {{ 'entities.buzzer-config.detailEntity' | translate }} }
          </h4>
          <button (click)="cancelEdit()" data-testid="detail-close" class="text-gray-400 hover:text-gray-600 transition-colors">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <!-- Body -->
        <div class="flex-1 overflow-auto px-8 py-4 flex flex-col gap-4">
          <!-- ===== SECTION INFORMATIONS (onglets par langue) — 3/4 ===== -->
          <div class="bg-gray-50 rounded-l p-5 border border-gray-100 h-[430px] flex flex-col min-h-0">
            <h3 class="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-3">
              <i class="fas fa-language mr-2"></i>{{ 'vues.buzzer-config.detail.sections.information' | translate }}
            </h3>
            <!-- Onglets de langue -->
            <div class="flex ml-2 items-center gap-1 z-10">
              @for (lang of languageLookup(); track lang.key; let i = $index) {
                <button class="px-4 py-1.5 text-sm font-medium rounded-t-md transition-colors"
                  [class.bg-white]="selectedLanguageIndex() === i"
                  [class.bg-gray-300]="selectedLanguageIndex() !== i"
                  [class.text-blue-600]="selectedLanguageIndex() === i"
                  [class.text-gray-500]="selectedLanguageIndex() !== i"
                  [class.border]="selectedLanguageIndex() === i"
                  [class.border-gray-300]="selectedLanguageIndex() === i"
                  [class.border-b-white]="selectedLanguageIndex() === i"
                  [class.hover:text-gray-700]="selectedLanguageIndex() !== i"
                  (click)="selectLanguage(i)">
                  {{ lang.value }}
                </button>
              }
            </div>
            <!-- Contenu de l'onglet sélectionné -->
            <div class="flex-1 bg-white -mt-[1px] z-0 border border-gray-300 rounded-lg p-4 space-y-2 min-h-0">
              <app-field-wrapper property="subject" label="entities.buzzer-config.propreties.subject" class="h-[10%] min-h-[60px]">
                <input type="text" [value]="getCurrentSubject()"
                  (input)="onSubjectChange($any($event.target).value)"
                  [disabled]="!isEditMode()"
                  class="flex-1 w-full border border-gray-300 rounded-lg p-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-100">
                </app-field-wrapper>
                <app-field-wrapper property="body" label="entities.buzzer-config.propreties.body" class="h-[80%] min-h-[80px]">
                  <textarea [value]="getCurrentBody()"
                    (input)="onBodyChange($any($event.target).value)"
                    [disabled]="!isEditMode()"
                  class="flex-1 w-full border border-gray-300 rounded-lg p-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-100 resize-y"></textarea>
                </app-field-wrapper>
              </div>
            </div>
            <!-- ===== SECTION CONFIGURATION — 1/4 ===== -->
            <div class="bg-gray-50 rounded-l p-4 border border-gray-100 h-[200px] mb-6">
              <h3 class="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-4 -mt-2">
                <i class="fas fa-cog mr-2"></i>{{ 'vues.buzzer-config.detail.sections.configuration' | translate }}
              </h3>
              <div class="flex gap-3 h-full items-center">
                <!-- Image 1/5 -->
                <div class="w-[10%] flex justify-center -mt-6">
                  <div class="relative w-[130px] h-[145px] border border-gray-300 overflow-hidden rounded-[10px] border-[3px] border-gray-100 shadow-[0_7px_7px_rgba(0,0,0,0.1)]">
                    <i class="fas fa-camera absolute inset-0 text-gray-300 text-[65px] flex items-center justify-center pointer-events-none" [ngClass]="{'hidden': imageUrl}"></i>
                    <img [src]="imageUrl || ''" class="w-full h-full object-cover" [ngClass]="{'hidden': !imageUrl}" />
                    <div class="absolute bottom-0 left-0 flex">
                      <input type="file" #fileInput accept="image/*" (change)="onFileSelected($event,'image.rawData_Path')" class="hidden" />
                      <button type="button" (click)="fileInput.click()" class="bg-teal-500 hover:bg-teal-800 text-white px-2 py-1 text-xs"><i class="fa fa-camera text-[0.9rem]"></i></button>
                      <button type="button" (click)="resetImage()" class="{{Skin.btnAlert}} px-2 py-1 text-xs"><i class="fas fa-times text-[0.9rem]"></i></button>
                    </div>
                  </div>
                </div>
                <!-- Champs : Show, Employee, StartDate, EndDate, Status sur une ligne -->
                <div class="w-[90%] flex gap-3 items-end mb-20">
                  <!-- Show (10%) -->
                  <div class="w-[10%] items-center pb-2">
                    <app-switch-button [checked]="editingEntity()?.show || false"
                      [disabled]="!isEditMode()"
                      [label]="'entities.buzzer-config.propreties.show' | translate"
                      labelPosition="top"
                    (checkedChange)="onShowChange($event)"></app-switch-button>
                  </div>
                  <!-- Employee (20%) -->
                  <app-field-wrapper property="selectedPK_Employee" businessProperty="fK_Employee" label="entities.buzzer-config.propreties.employee" class="w-[20%]">
                    <app-multi-select [options]="filteredEmployeeLookup()" [isMultiselect]="false"
                      [allowCreate]="false" [maxItems]="1" [placeholder]="'Employee'"
                      [selectedKeys]="editingEntity()?.['selectedPK_Employee'] || []"
                    (selectedKeysChange)="onEmployeeSelectChange($event)"></app-multi-select>
                  </app-field-wrapper>
                  <!-- PointOfService (20%) -->
                  <app-field-wrapper property="selectedPK_Pos" businessProperty="fK_PointOfService" label="entities.buzzer-config.propreties.fK_PointOfService" class="w-[20%]">
                    <app-multi-select [options]="pointOfServiceLookup()" [isMultiselect]="false"
                      [minChars]="0" [allowCreate]="false" [maxItems]="1"
                      [selectedKeys]="editingEntity()?.['selectedPK_Pos'] || []"
                    (selectedKeysChange)="onPOSselectChange($event)"></app-multi-select>
                  </app-field-wrapper>
                  <!-- StartDate (20%) -->
                  <app-field-wrapper property="startDate" label="entities.buzzer-config.propreties.startDate" class="w-[20%]">
                    <app-date-time-picker onReady [siteTimeZone]="fuseauDuSite" [selectedDateTime]="editingEntity()?.startDate ?? null"
                      [calendarAlign]="'bottom-left'" class="{{Skin.formInputSmallSize}} block bg-white"
                    (dateTimeChange)="onDateTimePropretyChange($event, 'startDate')"
                    (autoBind)="bindingHandler($event, 'startDate')"></app-date-time-picker>
                  </app-field-wrapper>
                  <!-- EndDate (15%) -->
                  <app-field-wrapper property="endDate" label="entities.buzzer-config.propreties.endDate" class="w-[15%]">
                    <app-date-time-picker onReady [siteTimeZone]="fuseauDuSite" [selectedDateTime]="editingEntity()?.endDate ?? null"
                      [calendarAlign]="'bottom-left'" class="{{Skin.formInputSmallSize}} block bg-white"
                    (dateTimeChange)="onDateTimePropretyChange($event, 'endDate')"
                    (autoBind)="bindingHandler($event, 'endDate')"></app-date-time-picker>
                  </app-field-wrapper>
                  <!-- Status (15%) -->
                  <app-field-wrapper property="status" label="entities.buzzer-config.propreties.status" class="w-[15%]">
                    <app-reactive-badge [status]="$safeNavigationMigration(editingEntity()?.status)" [lookupData]="translatedStatusLookup()"
                    [Skin]="Skin" [isEditMode]="true" (statusChange)="onStatusChange($event)"></app-reactive-badge>
                  </app-field-wrapper>
                </div>
              </div>
            </div>
          </div>
          <!-- Footer boutons -->
          <div class="bg-stone-50 px-8 py-3 border-t border-gray-200 flex space-x-2 justify-center">
            @if (HasEditPermission) {
              <button name="SaveButton" data-testid="detail-save" type="button" (click)="saveItem()"
                [disabled]="!isFormValid()" class="{{Skin.btnPrimary}} uppercase py-2 px-4">
                <i class="far fa-check-square mr-2"></i>{{ 'buttons.save' | translate }}
              </button>
            }
            @if (HasEditPermission) {
              <button name="SaveAndCloseButton" data-testid="detail-save-close" type="button" (click)="saveAndCloseItem()"
                [disabled]="!isFormValid()" class="{{Skin.btnPrimary}} uppercase py-2 px-4">
                <i class="far fa-check-square mr-2"></i>{{ 'buttons.save-and-close' | translate }}
              </button>
            }
            <button (click)="cancelEdit()" data-testid="detail-cancel" class="{{Skin.btnAlert}} uppercase py-2 px-4">
              <i class="fas fa-times mr-2"></i>{{ 'buttons.cancel' | translate }}
            </button>
          </div>
        </div>
      }
    }
